module.exports = __webpack_public_path__ + "static/media/p1ru.c4b28a17.pdf";